import AddToFavorites from "./AddToFavorites";

export default AddToFavorites;
